import styled from "styled-components"

const StyledInstruction = styled.section`
  padding: 50px 0;
  .order-courier {
    &__mobile-button {
      display: none;
    }
    &__header {
      text-align: center;
      font-size: 24px;
      line-height: 32px;
      margin: 0 0 85px 0;
    }
    &__row {
      display: flex;
      flex-wrap: wrap;
    }
    &__col {
      flex: 0 0 33.33333%;
      max-width: 33.33333%;
      &:not(:last-child) {
        padding: 0 80px 0 0;
      }
    }
    &__item {
      > div:first-child {
        display: flex;
        align-items: center;
      }
      &-number {
        display: flex;
        align-items: center;
        justify-content: center;
        min-width: 52px;
        height: 57px;
        font-size: 34px;
        line-height: 43px;
        background-color: #000;
        color: #00fb6e;
        margin: 0 20px 0 0;
      }
      &-header {
        font-size: 24px;
        line-height: 32px;
      }
      &-desc {
        margin: 25px 0 0 0;
        p {
          &:not(:last-child) {
            margin: 0 0 25px 0;
          }
        }
      }
    }
  }
  @media screen and (max-width: 1200px) {
    padding: 0;
    .order-courier {
      &__header {
        text-align: center;
        margin: 0 0 50px 0;
      }
      &__col {
        flex: 0 0 100%;
        max-width: 100%;
        &:not(:last-child) {
          margin-bottom: 50px;
          padding: 0;
        }
      }
      &__item {
        &-desc {
          p {
            &:not(:last-child) {
              margin: 0 0 15px 0;
            }
          }
        }
      }
    }
  }
  @media screen and (max-width: 900px) {
    display: ${({ show_form }) => (show_form ? "none" : "block")};
    .order-courier {
      &__mobile-button {
        display: block;
        text-align: center;
        margin: 40px 0 100px;
      }
    }
  }
  @media screen and (max-width: 600px) {
    .order-courier {
      &__wrapper {
        padding: 0 16px;
      }
      &__header {
        margin: 0 0 40px 0;
      }
      &__col {
        &:not(:last-child) {
          margin: 0 0 40px;
        }
      }
      &__item {
        &-number {
          margin: 0 20px 0 0;
        }
        &-desc {
          margin: 20px 0 0 0;
          p {
            &:not(:last-child) {
              margin: 0 0 20px 0;
            }
          }
        }
      }
    }
  }
`

export default StyledInstruction
